exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popover {\r\n    max-width:40em;\r\n}\r\n", ""]);

